import styles from './Typography.module.css';
export const TYPOGRAPHY_INLINE_ELEMENT_KIND_CONTENT_MAP = {
    'generic-big': 'span',
    generic: 'span',
    'generic-small': 'span',
    'generic-tiny': 'span',
    label: 'label',
};
export const TYPOGRAPHY_PARAGRAPH_ELEMENT_KIND_CONTENT_MAP = {
    'p-2XLarge': 'p',
    'p-xLarge': 'p',
    'p-large': 'p',
    p: 'p',
    'p-small': 'p',
    'p-tiny': 'p',
};
export const TYPOGRAPHY_ELEMENT_KIND_CONTENT_MAP = {
    ...TYPOGRAPHY_INLINE_ELEMENT_KIND_CONTENT_MAP,
    ...TYPOGRAPHY_PARAGRAPH_ELEMENT_KIND_CONTENT_MAP,
};
export const TYPOGRAPHY_ELEMENT_KIND_HEADING_MAP = {
    h1: 'h1',
    h2: 'h2',
    h3: 'h3',
    h4: 'h4',
    h5: 'h5',
    subtitle: 'p',
};
export const TYPOGRAPHY_ELEMENT_KIND_MAP = {
    ...TYPOGRAPHY_ELEMENT_KIND_CONTENT_MAP,
    ...TYPOGRAPHY_ELEMENT_KIND_HEADING_MAP,
};
export const TYPOGRAPHY_KIND_CLASS_MAP = {
    h1: styles.Heading1,
    h2: styles.Heading2,
    h3: styles.Heading3,
    h4: styles.Heading4,
    h5: styles.Heading5,
    subtitle: styles.Subtitle,
    'p-2XLarge': styles.Paragraph2XLarge,
    'p-xLarge': styles.ParagraphXLarge,
    'p-large': styles.ParagraphLarge,
    p: styles.ParagraphDefault,
    'p-small': styles.ParagraphSmall,
    'p-tiny': styles.ParagraphTiny,
    'generic-big': styles.GenericBig,
    generic: styles.Generic,
    'generic-small': styles.GenericSmall,
    'generic-tiny': styles.GenericTiny,
    label: styles.Label,
};
export const TYPOGRAPHY_ALIGN_CLASS_MAP = {
    center: styles.AlignCenter,
    inherit: styles.AlignInherit,
    left: styles.AlignLeft,
    right: styles.AlignRight,
};
export const TYPOGRAPHY_COLOR_CLASS_MAP = {
    accent: styles.AccentColor,
    default: styles.DefaultColor,
    muted: styles.MutedColor,
    alert: styles.AlertColor,
    positive: styles.PositiveColor,
    negative: styles.NegativeColor,
    informative: styles.InformativeColor,
    inherit: styles.InheritColor,
    inverted: styles.InvertedColor,
};
export const TYPOGRAPHY_FONT_WEIGHT_CLASS_MAP = {
    regular: styles.Regular,
    medium: styles.Medium,
    bold: styles.Bold,
};
/**
 * As Typography is being used to render dynamic data
 * as names, emails, etc..., we may need to
 * adjust the word breaking behavior in some cases.
 * For example having having names so long that they break
 * the UI. This might be addressed in a better way
 * in a next iteration of the design system.
 */
export const TYPOGRAPHY_WORD_BREAK_CLASS_MAP = {
    breakAll: styles.BreakAll,
    breakWord: styles.BreakWord,
    normal: undefined,
};
